// extracted by mini-css-extract-plugin
export default {"root":"ProductListModal_root__yq1P9"};